module.exports = __webpack_public_path__ + "img/step4a-en@2x.bf579ce0.webp";